module.exports = __webpack_public_path__ + "static/media/project-default.3ee5f9aa.jpg";